module.exports = __webpack_public_path__ + "static/allip-367d7e4c8ca5db3c75144c87755a6fd5.png";